<template>
<transition name="fade">
    <div class="cn-alert" v-if="isAlert">
      <p>{{massage}}</p>
    </div>
  </transition>
</template>

<script>
export default {
  // props:['massage','isAlert']
  data(){
    return{
      massage:'',
      isAlert:false
    }
  }
}
</script>

<style scoped>
.cn-alert{
  width: 100%;
  position: fixed;
  bottom: 1.6rem;
  display: flex;
  z-index: 10000
}
.cn-alert p{
  padding:.3rem;
  color: #fff;
  font-size: .34rem;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 0.16rem;
  margin: 0 auto ;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/common/cmpnt/cnAlert.vue